<template>
  <div class="notice-popup" v-if="noticeVisible">
    <div class="popup-shadow" @click="hideNoticePopup"></div>
    <div class="popup-container">
      <div class="title">{{ titleText }}</div>
      <div class="tips-content" v-html="content"></div>
      <div @click="goRightsCenter()" class="notice-btn">{{ letter.go }}</div>
      <div class="popup-close" @click="hideNoticePopup"></div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import languages from '@store/languages/index';
import {
  clickButton,
  popupType,
  showPopup
} from '@plugins/biPoint/_configWebstoreV2';
import globalConfig from '@utiles/officialStore/globalConfig';
import openActivity, { NOTICE_POPUP_ACTIVITY } from '@utiles/openActivity';
import {
  getGlobalGetGotoLink,
  getGlobalGetLinkParams
} from '@utiles/globalGetLink';
export default {
  name: 'NoticePopup',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      noticeVisible: false,
      content: ''
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      letter: state => state.letter,
      gameId: state => state.gameId
    }),
    ...mapGetters(['gameInfoConfig']),

    titleText() {
      return this.letter.notice;
    },
    offLineTime() {
      return this.gameInfoConfig?.offLineTime || '';
    }
  },
  methods: {
    hideNoticePopup() {
      this.noticeVisible = false;
    },
    getRightsIntro() {
      return (
        this.letter.preRightsIntro.replace(
          '${offLineDate}',
          this.gameInfoConfig?.offLineDate[this.lang] ||
            this.gameInfoConfig?.offLineDate['en-US'] ||
            ''
        ) || ''
      );
    },
    goRightsCenter() {
      clickButton({
        btnName: 'go_right_center',
        locationKey: this.$route.meta.pageName,
        otherParams: {
          link: this.gameInfoConfig?.rightsCenterLink,
          name: 'rightCenterPage'
        }
      });
      let jumpLink = '';
      if (this.gameInfoConfig?.isOnlineRightsCenter) {
        jumpLink = this.gameInfoConfig?.preRightsPopupLink
          ? this.gameInfoConfig?.preRightsPopupLink
          : this.gameInfoConfig?.rightsCenterLink;
        openActivity(NOTICE_POPUP_ACTIVITY, jumpLink, {
          language: this.lang,
          appLanguage: this.lang,
          ...getGlobalGetLinkParams()
        });
      } else {
        // 获取当前的链接
        jumpLink = window.location.href + 'vip_score';
        sdkOpenLink({
          link: jumpLink
        });
      }
      this.noticeVisible = false;
    },
    getSpecifyLang(lang, key) {
      return languages.getSpecifyLang(lang, key);
    },
    showRightCenterPopup() {
      // 在offLineTime之后不再弹窗 || 关掉显示弹窗
      if (!this.offLineTime || !this.gameInfoConfig?.isShowPreRightsPopup) {
        return;
      }
      // 公告截止时间
      const announcementEndTime = new Date(this.offLineTime);
      // 获取当前时间（考虑时区）
      const currentTime = new Date();
      // 获取用户当前时区偏移量（分钟）
      const currentTimeZoneOffset = currentTime.getTimezoneOffset();
      // 调整当前时间为UTC时间，以便与公告截止时间比较
      const currentUTCTime = new Date(
        currentTime.getTime() - currentTimeZoneOffset * 60000
      );
      // 检查当前时间是否超过公告截止时间
      if (currentUTCTime > announcementEndTime) {
        return;
      }
      let RIGHT_CENTER_POPUP_STATE = 'RIGHT_CENTER_POPUP_STATE' + this.gameId;
      if (!+globalConfig.getCookie(RIGHT_CENTER_POPUP_STATE)) {
        showPopup(popupType.rightCenterPopup);
        this.content = this.getRightsIntro();
        this.noticeVisible = true;
        // 3s后设置cookie, 避免刷新误触发
        setTimeout(() => {
          globalConfig.setCookie(RIGHT_CENTER_POPUP_STATE, 1);
        }, 3000);
      }
    }
  },
  mounted() {
    this.showRightCenterPopup();
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/officialWebStore.scss';

.notice-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
}

.popup-shadow {
  position: absolute;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
}

.popup-container {
  position: relative;
  box-sizing: border-box;
  border-radius: 10px;
  background: #fff;
  width: 565px !important;
}

.title {
  text-align: center;
  height: 87px;
  line-height: 87px;
  font-size: 26px;
  @include g-popup-title();
  margin: 0;
  border-radius: 10px;
  font-weight: bold;
}

.tips-content {
  display: block;
  box-sizing: border-box;
  padding: 30px 40px 30px 40px;
  line-height: 30px;
  font-size: 18px;
  clear: both;
  margin: 0 auto;
  width: 100%;
  height: auto;
  overflow-y: auto;
  max-height: 500px;
  // vertical-align: middle;
  text-align: center;
  // color: var(--global-tip-popup-text);
}

.notice-btn {
  width: 220px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 30px;
  // line-height: 65px;
  height: 65px;
  font-size: 24px;
  color: #fff;
  font-weight: bold;
  background: $btnBg;
  border-radius: 10px;
  cursor: pointer;
}

.popup-close {
  position: absolute;
  right: 32px;
  top: 27px;
  background: url($tmslgImg + 'close.png') no-repeat;
  width: 28px;
  height: 28px;
  cursor: pointer;
}

@media screen and (orientation: landscape) {
  .popup-container {
    width: $landscapePopupWidth;
  }

  .title {
    height: 61px;
    line-height: 61px;
    font-size: 22px;
  }

  .popup-close {
    position: absolute;
    right: 15px;
    top: 19px;
    background: url($tmslgImg + 'close.png') no-repeat;
    width: 23px;
    height: 23px;
    cursor: pointer;
    background-size: cover;
  }
}
</style>
